// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062359/js/" + chunkId + "." + {"44":"16773c61","225":"0d96f913","481":"44eb0082","486":"474220dd","770":"5ad022a2"}[chunkId] + ".0.9780880150518604.chunk.js";
};